module.exports = __webpack_public_path__ + "img/plane-up.10ae4aa5.svg";